// extracted by mini-css-extract-plugin
module.exports = {"tutors":"Tutors-module__tutors___1pE76 Index-module__tutors___5ZfuJ","tutor":"Tutors-module__tutor___2WwVl undefined","image":"Tutors-module__image___1QUgd"};